export default __webpack_public_path__ + "static/media/terrafinder.6c4bb07a.jpg";